var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.5,
    height: 79.804,
    viewBox: "0 0 44.5 79.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(-1510 -653.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M4.923,25.763l1.965-.438a131.477,131.477,0,0,1,26.97-3.144,2.239,2.239,0,0,0,2.132-2.827l-.548-2.012a48.07,48.07,0,0,1-1.63-14.99A2.239,2.239,0,0,0,31.069.06L30.72.141a131.477,131.477,0,0,1-26.882,3.4l-1.647.037a2.239,2.239,0,0,0-2.1,2.848L.45,7.707A48.072,48.072,0,0,1,2.232,22.57l-.034.924a2.239,2.239,0,0,0,2.725,2.268",
    transform: "translate(1510 653.765)",
    fill: "#ffe0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M60.136,178.891c-.32-.171-.486,1.935-.486,1.935s-.6-3.75-.8-4.4-1.275,1.1-1.218.995c-.427-.228-.89.9-.841,1.059-.811-.022-.513.96-1.061,1.215-.205,1.378.9,3.539,1.407,4.442l-.014.005a19.248,19.248,0,0,1,1.715,4.4,35.743,35.743,0,0,0,3.786-.833l-1.71-3.791a2.753,2.753,0,0,1-.188-1.6,6.484,6.484,0,0,0-.59-3.428",
    transform: "translate(1460.271 496.405)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M87.584,285.225s-2.034-7.629-4.374-8.036-5.29,0-5.29,1.322,4.272,7.629,5.7,8.952,3.967-2.238,3.967-2.238",
    transform: "translate(1440.441 406.453)",
    fill: "#54869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6967",
    "data-name": "Path 6967",
    d: "M219.33,453.332c.1.407,1.017,4.171-.407,6.714s-10.071-5.595-10.071-5.595l-.1-3.459Z",
    transform: "translate(1323.648 251.164)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6968",
    "data-name": "Path 6968",
    d: "M31.08,541.065,26.9,529.88l5.168-1.906,1.9,10.75a4.24,4.24,0,0,0,1.089,2.188,6.4,6.4,0,0,1,1.35,2.043,1.266,1.266,0,0,1-.51,1.623l-8.182,3.876c-.458.2-.976-.384-.8-.9.264-.757,1.19-1.472,2.287-3.07a12.293,12.293,0,0,1,1.513-1.834,1.489,1.489,0,0,0,.364-1.585",
    transform: "translate(1486.004 182.442)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6969",
    "data-name": "Path 6969",
    d: "M19.462,452.624s-.61,11.6,1.831,12.207,6.1-.407,6.714-2.441a10.532,10.532,0,0,0-.2-4.883s9.562,11.516,16.683,8.057c5.407-2.626-16.683-17.416-16.683-17.416Z",
    transform: "translate(1492.687 253.703)",
    fill: "#54869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6970",
    "data-name": "Path 6970",
    d: "M58.8,563.139l-4.948-10.867,5.023-2.261L61.518,560.6a4.241,4.241,0,0,0,1.239,2.107,6.4,6.4,0,0,1,1.489,1.944,1.265,1.265,0,0,1-.4,1.655l-7.892,4.436c-.443.232-1-.315-.857-.843.21-.773,1.085-1.551,2.067-3.222a12.29,12.29,0,0,1,1.382-1.934,1.489,1.489,0,0,0,.253-1.607",
    transform: "translate(1461.923 162.77)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6971",
    "data-name": "Path 6971",
    d: "M157.111,203.139s1.053,3.33,2.656,3.654c-.489,2.12-3.036,4.149-5.444,3.378s-2.683-4.653-2.683-4.653Z",
    transform: "translate(1374.631 472.423)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    d: "M152.682,220.739a3.91,3.91,0,0,0,1.926-2.466,1.37,1.37,0,0,0-.791-1.787l-2.177.947a8.065,8.065,0,0,0,1.042,3.306",
    transform: "translate(1374.631 460.507)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6973",
    "data-name": "Path 6973",
    d: "M49.281,199.6c-.342-.121-.187,1.986-.187,1.986s-1.162-3.616-1.458-4.233-1.093,1.282-1.053,1.168c-.456-.161-.744,1.02-.67,1.174-.8.1-.362,1.027-.865,1.362.006,1.394,1.426,3.362,2.065,4.177l-.013.007a19.248,19.248,0,0,1,2.362,4.09,35.741,35.741,0,0,0,3.616-1.4l-1.945-2.994a4.93,4.93,0,0,1-.758-2.3,6.458,6.458,0,0,0-1.094-3.036",
    transform: "translate(1469.786 477.7)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6974",
    "data-name": "Path 6974",
    d: "M81.741,235.715a1.766,1.766,0,0,1,2.34.509c.916,1.322,2.543,4.171,2.543,4.171s-.305-4.273.915-6.1,5.7-5.595,7.935-5.29,7.324,3.357,8.952,8.85,2.645,15.666,1.017,18.31-9.054,3.56-10.986,2.747-5.188-4.883-5.188-4.883l.2-3.052s-1.424,1.322-2.543.712-8.443-10.783-8.138-12.919,2.95-3.052,2.95-3.052",
    transform: "translate(1439.672 449.351)",
    fill: "#6aa1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6975",
    "data-name": "Path 6975",
    d: "M157.917,464.12c-7.324-2.95-9.38-.824-11.8-1.068l3.262-.682s3.255,4.069,5.188,4.883c1.23.518,4.685.334,7.454-.549-.465-.8-3.185-2.213-4.1-2.583",
    transform: "translate(1379.561 241.008)",
    fill: "#54869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6976",
    "data-name": "Path 6976",
    d: "M36.081,438.948s17.386,6.322,5.1,14.63c-3.978,2.69-17-8.38-17-8.38a19.863,19.863,0,0,1,1.585,5.8c.02,1.62-3.208,3.03-5.022,3.695a1.421,1.421,0,0,1-1.762-.7c-1.808-3.613-7.227-15.01-4.882-17.36,2.8-2.8,8.5-2.279,11.17-2.023,2.39.229,10.809,4.332,10.809,4.332",
    transform: "translate(1497.928 265.973)",
    fill: "#6aa1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6977",
    "data-name": "Path 6977",
    d: "M125.879,134.733s-1.942,4.879-6.415,3.447-3.962-11.322-1.174-12.326,8.932,1.722,7.589,8.879",
    transform: "translate(1406.313 541.595)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6978",
    "data-name": "Path 6978",
    d: "M109.918,67.533a2.754,2.754,0,0,0-2.881-2.445c-1.7.11-5.386-.446-4.563-4.5,1.243-6.132,7.884-6.174,13.517-4.592,5.417,1.522,7.585-5.917,11.714-4.595s12.62,12.16,5.286,15.493c-6.714,3.052-9.693.061-12.817,1.526s-4.821,3.065-8.017,2.446c-1.5-.29-2.062-1.8-2.24-3.33",
    transform: "translate(1418.627 608.024)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6979",
    "data-name": "Path 6979",
    d: "M176.577,363.012a23.323,23.323,0,0,0,2.638-8.524c.509,3.052-1.729,10.274-2.747,10.173-.305-.407.108-1.649.108-1.649",
    transform: "translate(1352.566 337.313)",
    fill: "#54869b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4400",
    "data-name": "Rectangle 4400",
    width: 44.5,
    height: 79.804,
    transform: "translate(1510 653.766)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleSide);
export default __webpack_public_path__ + "static/media/sleepStyleSide.674a404a4530d05c5325d6d77d032cf0.svg";
export { ForwardRef as ReactComponent };